import React, { FC, useMemo } from 'react'
import Grid from '@sport1/react-elements/Grid'
import SmallBodyFont from '../../../../Theme/Fonts/SmallBody'
import CompetitorImage from '../../../../BaseComponents/Image/Team'
import { MatchCompetitorProps } from '.'

const BaseMatchCompetitor: FC<MatchCompetitorProps> = ({
    type,
    name,
    isBold,
    logoUrl,
    logoAlt,
    resizeMode,
    textPaddingLeft,
    textPaddingRight,
}) => {
    const labelComponent = useMemo(
        () => (
            <Grid minWidth={0} centerVertical>
                <SmallBodyFont
                    bold={isBold}
                    numberOfLines={1}
                    textAlign={type === 'home' ? 'right' : 'left'}
                    paddingLeft={textPaddingLeft}
                    paddingRight={textPaddingRight}
                >
                    {name}
                </SmallBodyFont>
            </Grid>
        ),
        [isBold, name, textPaddingLeft, textPaddingRight, type]
    )

    const imageComponent = useMemo(
        () => (
            <Grid
                noExpand
                paddingLeft={type === 'home' ? '6px' : 0}
                paddingRight={type === 'away' ? '6px' : 0}
                zIndex={10}
            >
                <CompetitorImage
                    alt={logoAlt}
                    imageUrl={logoUrl}
                    size="L"
                    width={18}
                    resizeMode={resizeMode}
                />
            </Grid>
        ),
        [logoAlt, logoUrl, resizeMode, type]
    )

    return type === 'home' ? (
        <>
            {labelComponent}
            {imageComponent}
        </>
    ) : (
        <>
            {imageComponent}
            {labelComponent}
        </>
    )
}

export default BaseMatchCompetitor
